import React from "react";
import { Modal, Button, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

const AdminConfirmDeleteTripModal = ({ open, onCancel, onConfirm, tripData, loading }) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      width={400}
      zIndex={1080}
      centered
      closable={false}
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <ExclamationCircleOutlined style={{ fontSize: "48px", color: "#ff4d4f", marginBottom: "16px" }} />
        <Title level={4}>Cancel Trip?</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: "24px" }}>
          Are you sure you want to cancel this scheduled trip? 
          All confirmed passengers will be notified by email. This action cannot be undone.
        </Text>
        
        <div style={{ display: "flex", justifyContent: "center", gap: "12px", width: "100%" }}>
          <Button onClick={onCancel} style={{ flex: 1 }}>Back</Button>
          <Button className="ouber-btn-danger" onClick={() => onConfirm(tripData)} style={{ flex: 1, margin: 0 }} loading={loading}>
            Confirm Cancellation
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AdminConfirmDeleteTripModal;
